export const getActivityTxs = ({ txs, asset }) => {
  return txs.flatMap((tx) => {
    const { claim, reward } = tx.data
    const txs = []
    if (claim) {
      const claimAmount = asset.currency.defaultUnit(claim)
      txs.push({
        ...tx,
        data: { claim, meta: 'derivedFromGetActivityTxs' },
        coinAmount: claimAmount,
      })
    }

    if (reward) {
      const rewardAmount = asset.currency.defaultUnit(reward)
      txs.push({
        ...tx,
        data: { reward, meta: 'derivedFromGetActivityTxs' },
        coinAmount: rewardAmount,
      })
    }

    return txs.length > 0 ? txs : [tx]
  })
}
